// extracted by mini-css-extract-plugin
export var arrows = "_70-5";
export var decrementer = "_70-9";
export var disabled = "_70-3";
export var error = "_70-1";
export var hiddenText = "_70-a";
export var incrementer = "_70-8";
export var input = "_70-7";
export var inputWrapper = "_70-0";
export var leadingIcon = "_70-b";
export var readonly = "_70-2";
export var regular = "_70-6";
export var small = "_70-4";